import { action, observable } from 'mobx';
import { AlignedElementDesignParamsRequestDTO, HydroParamsDTO, DesignControlDTO, AlignedElementDesignParamsResponseDTO } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { HydroByAlignmentAoiController, DesignElementController, WaterwayDesignToolsController } from 'cd-eft/services/eftSetApi';
import { EftProjUserInputController, EftProjectController } from 'cd-eft/services/eftPrjAdminApi'
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import stores from "cd-eft/models/Stores";
import { HydroProjectMetadataRespDTO, EftProjUserInputDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { WaterwayCommentsVM } from './WaterwayComments/WaterwayCommentsVM';
import { toDecimalPrecision } from 'cd-eft/utils/mathUtilities';
import { DynamicWaterwayProfileStore } from 'cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayProfileStore';
import { DesignContainerVM } from 'cd-eft/components/Design/DesignContainer/DesignContainerVM';
import MapView from "@arcgis/core/views/MapView.js";
import { AppConstants } from 'cd-eft/appConstants';
import { GraphicsLayer } from "cd-eft/utils/esriTypes";
import { putStructureRepOnTop } from 'cd-eft/utils/gisUtils';
import { DisplayAlignment } from 'cd-eft/components/SurveyEngineering/Maps/SETMapFunctions/loadLayers';
import { appConfig } from 'cd-eft/config/AppConfig';
import { getListOfDesignElements } from 'cd-eft/components/Design/common/ElementContainer/ElementContainerVM';
import sleep from 'cd-eft/utils/sleep';
import { formatRound } from "cd-eft/utils/mathUtilities";
import { DynamicWaterwayTableStore } from 'cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayTableStore';
import { DynamicWaterwayHub } from 'cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayHub';
export const D50_ROCK_RIPRAP = 'D₅₀=6in Rock Riprap (0.045, 9)';

interface IAoi {
    state: string,
    county: string

}
interface ISelection {
    name: string,
    value: string | number,
    optionDisabled?: boolean,
    manning?: number,
    liningThickness?: number,
}
interface IDesignControlForm {
    sideFillSlope: number;
    sideWidthLimit: number;
    bermTopWidth: number;
    bermBackSlope: number;
    startGradeLength: number;
    startGradeSlope: number;
    endGradeLength: number;
    endGradeSlope: number;
    freeBoard: number;
    channelControl: 'TRAPEZOIDAL' | 'PARABOLIC';
    channelEndControl: 0 | 1; // 0=length, 1=slope,
    seedingBufferOption: number;

}
interface IHydroByAlignmentAoiData {
    projectTitle: string,
    projectUuid: string,
    errorCode: string
}
export interface WaterwayMiscDTO {
    benchmarkDescription: string;
    spoilDisposal?: string;
    waterwayMaterial?: string;
}

export const liningMaterialOptions = [
    { name: 'Concrete (0.013, 10)', value: 'Concrete', manning: 0.0130, liningThickness: 10 },
    { name: D50_ROCK_RIPRAP, value: 'D50=6in Rock Riprap', manning: 0.0450, liningThickness: 9 },
    { name: 'Gravel (0.029, 4)', value: 'Gravel', manning: 0.0290, liningThickness: 4 },
    { name: 'Turf Reinforcement Mat (0.031, 0.63)', value: 'Turf Reinforcement Mat', manning: 0.0310, liningThickness: 0.63 },
    { name: 'Manual Entry', value: 'Manual Entry', manning: 0, liningThickness: 0 }
];

const designStore = stores.AppStore.designStore;
const waterwayDesignStore = stores.AppStore.waterwayDesignStore;
const alignmentStore = stores.AppStore.alignmentDesignStore;
const gisModel = stores.AppStore.surveyEngineeringStore.gisModel;

const WDTAPI = WaterwayDesignToolsController;
export class WaterwayInputVM {
    private tableStore: DynamicWaterwayTableStore;
    @observable isWaterwayDesign: boolean;
    constructor(props: any = null, isWaterwayDesign: boolean = false) {
        this.props = props;
        this.isWaterwayDesign = isWaterwayDesign;
        this.mapView = DesignContainerVM.mapView;
        const hub = new DynamicWaterwayHub();
        this.tableStore = new DynamicWaterwayTableStore(hub);
        // this.isManualEntry = false;
        // this.selectedLiningMaterial = '';
        // this.disabledManualEntrySave = true;
        // this.selectedLiningMaterialTemporary = '';
    }
    private profileStore!: DynamicWaterwayProfileStore;
    @observable props;
    @observable mapView?: MapView;
    @observable isNotInitialRender: boolean = false;
    // @observable disableSavebutton: boolean = true;
    // @observable disableSaveProccedbutton: boolean = true;
    @observable disableChannelType: boolean = false;
    @observable waterwayCommentsVM = new WaterwayCommentsVM();
    @observable onClickInformation = false;
    @observable onClickMetaData = false;
    @observable waterWayWizardStatus: number = 1;  // 1: default, 2: success, 3:error
    @observable headerTitle = "";
    @observable onClickMetadata = false
    @observable isUpdating: boolean = false;
    @observable originalStartGradeLength?: number;
    @observable originalEndGradeLength?: number;
    @observable projectDetails = {
        status: "",
        state: "",
        county: "",
        watershedCentroid: "",
        owner: "",
        lastChangeBy: "",
        lastChangeDate: "",
    }
    // getHydroByAlignmentAoiData() API data
    @observable HydroByAlignmentAoiData: IHydroByAlignmentAoiData[] = [];
    //info section 
    @observable waterwayName = "";
    @observable constructionBenchmark = "";
    @observable constructionElevation: number = 0;

    // @observable selectedLiningMaterial: string = '';
    @observable benchmarkDescription: string = '';
    @observable spoilDisposal: string = '';

    //alignment section
    @observable seedingBufferWidth = 0.00;
    @observable selectedAlignmentId = 0;
    //Hydrology section
    @observable alignmentOptions: ISelection[] = [];
    //Hydrology section
    @observable hydrologyProjectOptions: ISelection[] = [
        {
            name: 'User Defined',
            value: 'User Defined'
        }
    ];
    @observable hydrologyFrequencyOptions: ISelection[] = [
        {
            name: '1 year',
            value: '1 year',
        },
        {
            name: '2 year',
            value: '2 year',
        },
        {
            name: '5 year',
            value: '5 year',
        },
        {
            name: '10 year',
            value: '10 year',
        },
        {
            name: '25 year',
            value: '25 year',
        },
        {
            name: '50 year',
            value: '50 year',
        },
        {
            name: '100 year',
            value: '100 year',
        },
    ]

    @observable hydrologyForm = {
        hydrologyProjectSlection: "",
        hydrologyFrequencySelection: '10 year',
        initialQFraction: 100.00,
    }
    @observable designControlForm: IDesignControlForm = {
        sideFillSlope: 0.5,
        sideWidthLimit: 30.00,
        bermTopWidth: 4.00,
        bermBackSlope: 4.00,
        startGradeLength: 0.00,
        startGradeSlope: 0.00,
        endGradeLength: 0.00,
        endGradeSlope: 0.00,
        freeBoard: (waterwayDesignStore.waterwayType === 'Lined Waterway' ||
            waterwayDesignStore.currentWaterwayDesignElementTypeId === 19) ? 0.25 : 0.00,
        channelControl: 'TRAPEZOIDAL',
        channelEndControl: 0, // 0=length, 1=slope,
        seedingBufferOption: 1
    }
    @observable infoFormValidation = {
        hasError: false,
        waterway_name: false,
        formErrors: {
            waterway_name: "",
        }
    }

    @observable liningMaterialFormValidation = {
        liningMaterialOption: true,
        manualEntryMaterialName: true,
        manualEntryManning: true,
        manualEntryThickness: true,
        formErrors: {
            liningMaterialOption: '',
            manualEntryMaterialName: '',
            manualEntryManning: '',
            manualEntryThickness: '',
        }
    }
    @observable alignmentFormValidation = {
        hasError: false,
        canSave: false,
        alignment: false,
        alignmentEmpty: true,
        seedingBufferWidth: false,
        formErrors: {
            alignment: "",
            seedingBufferWidth: ""
        }
    }
    @observable hydrologyFormValidation = {
        hasError: false,
        canSave: false,
        peak_flow: false,
        hydrologyProject: false,
        initialQFraction: false,
        hydrologyProjectEmpty: true,
        peakFlowEmpty: true,
        formErrors: {
            peak_flow: "",
            initialQFraction: "",
            hydrologyProject: ""
        }
    }

    @observable designControlFormValidation = {
        hasError: false,
        sideFillSlope: false,
        sideWidthLimit: false,
        bermTopWidth: false,
        bermBackSlope: false,
        startGradeLength: false,
        startGradeSlope: false,
        endGradeLength: false,
        endGradeSlope: false,
        freeBoard: false,
        channelControl: false,
        channelEndControl: false,
        formErrors: {
            sideFillSlope: "",
            sideWidthLimit: "",
            bermTopWidth: "",
            bermBackSlope: "",
            startGradeLength: "",
            endGradeLength: "",
            startGradeSlope: "",
            endGradeSlope: "",
            freeBoard: "",
            channelControl: "",
            channelEndControl: "",
        }

    }
    @observable hydroProjectMetadata: HydroProjectMetadataRespDTO = {
        county: "",
        drainageArea: undefined,
        frequencyInYrs: undefined,
        lastChangedBy: "",
        lastChangedDate: "",
        peakFlow: undefined,
        projectOwner: "",
        projectStatus: "",
        projectUuid: "",
        runOff: undefined,
        state: "",
        waterShedUrl: "",
        watershedCentroid: undefined,
        watershedLength: undefined,
        watershedSlope: undefined,
        weightedCurveNumber: undefined
    };
    // action buttons in comment section 
    // AOI(State and County) county, format: Lowercase state:shorten and Uppercase!!!
    @observable Aoi: IAoi = {
        // county: 'adair',
        // state: 'IA'
        county: designStore.projectsStore.currentProject.county,
        state: designStore.projectsStore.currentProject.state
    }
    @observable metadataCardStormCollapse: boolean = true;
    @observable metadataCardProjectCollapse: boolean = true;

    private channelGradeLengthChanged: boolean = false;
    private channelSlopeChanged: boolean = false;
    private originalStartLength: number = 0;
    private originalEndLength: number = 0;
    private hasWDT122Warning: boolean = false;

    // liniing material section
    @observable liningMaterialOptions: ISelection[] = [...liningMaterialOptions];
    @observable liningMaterailForm = {
        selectedLiningMaterail: '',
        manning: 0,
        thickness: 0,
        manualEntryLiningMaterailName: '',
        disabledManual: true
    }
    // index 0: is lining material comfirmation show?; index 1: onChange name; index 2: onchange value to store the temprerary lining material
    @observable showLiningMaterialConfirmation = [false, '', ''];

    @observable updateTrigger: number = 0;

    @action.bound resetLiningMaterialManualEntry() {
        this.liningMaterailForm.manualEntryLiningMaterailName = '';
        this.liningMaterailForm.manning = 0.0000;
        this.liningMaterailForm.thickness = 0;
        this.liningMaterialFormValidation.manualEntryMaterialName = true;
        this.liningMaterialFormValidation.manualEntryManning = true;
        this.liningMaterialFormValidation.manualEntryThickness = true;
        this.liningMaterialFormValidation.formErrors.manualEntryManning = '';
        this.liningMaterialFormValidation.formErrors.manualEntryMaterialName = '';
        this.liningMaterialFormValidation.formErrors.manualEntryThickness = '';
    }

    @action.bound confirmLiningMaterialChangeAction = async () => {
        const event = { target: { name: this.showLiningMaterialConfirmation[1], value: this.showLiningMaterialConfirmation[2] } };
        this.handleLiningMaterialOnChange(event);
        await this.validateLinedMaterialInput(this.showLiningMaterialConfirmation[1], this.showLiningMaterialConfirmation[2])
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        this.showLiningMaterialConfirmation = [false, '', ''];
    };

    @action.bound cancelLiningMaterialChangeAction = () => {
        this.showLiningMaterialConfirmation = [false, '', ''];
    };


    @action.bound resetValues = () => {
        if (designStore.toggleResetValues) {
            this.updateValuesFromUndoPEM();
        }
    };

    @action.bound toggleMetadataCardStorm() {
        this.metadataCardStormCollapse = !this.metadataCardStormCollapse;
    }
    @action.bound toggleMetadataCardProject() {
        this.metadataCardProjectCollapse = !this.metadataCardProjectCollapse;
    }

    @action.bound async getHydroByAlignmentAoiData() {
        try {
            const response: any = await HydroByAlignmentAoiController.getHydrologyProjectsByAlignmentAOIUsingPOST(this.Aoi);
            if (response.data.length > 0) {
                this.HydroByAlignmentAoiData = response.data;
                if (this.HydroByAlignmentAoiData.length === 1 && this.HydroByAlignmentAoiData[0]['projectTitle'] ===
                    'User Defined') {
                    const shortCode = this.HydroByAlignmentAoiData[0].errorCode.replace(/[123]_[a-zA-Z]+_[a-zA-Z]+_/, '');
                    await MessageCenter.addNotificationFromCode(shortCode);
                }
                else {
                    this.hydrologyProjectOptions.push(...this.HydroByAlignmentAoiData.map(element => { return { name: element.projectTitle, value: element.projectUuid } }));
                }
            }
        } catch (error) {
            // console.error('getHydrologyProjectsByAlignmentAOIUsingPOST error:', error);
        }
    }
    @action.bound async validationBlock(name, value) {
        let val;
        if (name === 'manning') {
            val = formatRound(parseFloat(value), 4);
            this.liningMaterailForm.manning = val;
        }
        switch (name) {
            case 'waterway_name':
                if (value === '') {
                    this.infoFormValidation.waterway_name = true;
                    this.infoFormValidation.formErrors.waterway_name = 'usa-input--error';
                    this.infoFormValidation.hasError = true;
                } else {
                    this.infoFormValidation.waterway_name = false;
                    this.infoFormValidation.formErrors.waterway_name = '';
                }
                break;
            case 'alignment':
                if (value === "" || value === 0 || value === undefined) {
                    this.alignmentFormValidation.alignment = true;
                    this.alignmentFormValidation.formErrors.alignment = 'usa-input--error';
                    this.alignmentFormValidation.hasError = true;
                    this.alignmentFormValidation.alignmentEmpty = true;

                } else {
                    this.alignmentFormValidation.alignment = false;
                    this.alignmentFormValidation.formErrors.alignment = '';
                    this.alignmentFormValidation.alignmentEmpty = false;
                    if (this.selectedAlignmentId) this.displayAlignment(this.selectedAlignmentId);
                }
                break;
            case 'seeding_buffer_width':
                if (value === '' || value < 0.00) {
                    await MessageCenter.addNotificationFromCode('Common_11', undefined, "Seeding Buffer Width (ft) ");
                    this.alignmentFormValidation.seedingBufferWidth = true;
                    this.alignmentFormValidation.formErrors.seedingBufferWidth = 'usa-input--error';
                    this.alignmentFormValidation.hasError = true;
                } else {
                    this.alignmentFormValidation.seedingBufferWidth = false;
                    this.alignmentFormValidation.formErrors.seedingBufferWidth = '';
                }
                break;
            case 'peak_flow':
                if (value === "" || value === undefined || value < 0.01 || value > 1000) {
                    this.hydrologyFormValidation.peak_flow = true;
                    this.hydrologyFormValidation.formErrors.peak_flow = 'usa-input--error';
                    this.hydrologyFormValidation.hasError = true;
                    if (value === '' || value === undefined) {
                        this.hydrologyFormValidation.peakFlowEmpty = true;
                    }
                    else {
                        await MessageCenter.addNotificationFromCode('WDT_40');
                    }
                } else {
                    this.hydrologyFormValidation.peak_flow = false;
                    this.hydrologyFormValidation.formErrors.peak_flow = '';
                    this.hydrologyFormValidation.peakFlowEmpty = false;
                }
                break;
            case 'initialQFraction':
                if (value === '' || value < 0.00 || value > 100.0) {
                    await MessageCenter.addNotificationFromCode('WDT_79');
                    this.hydrologyFormValidation.initialQFraction = true;
                    this.hydrologyFormValidation.formErrors.initialQFraction = 'usa-input--error';
                    this.hydrologyFormValidation.hasError = true;
                } else {
                    this.hydrologyFormValidation.initialQFraction = false;
                    this.hydrologyFormValidation.formErrors.initialQFraction = '';
                }
                break;
            case 'hydrology_project':
                if (value === "" || value === 0 || value === undefined) {
                    this.hydrologyFormValidation.hydrologyProject = true;
                    this.hydrologyFormValidation.formErrors.hydrologyProject = 'usa-input--error';
                    this.hydrologyFormValidation.hasError = true;
                    if (value === '' || value === undefined) {
                        this.hydrologyFormValidation.hydrologyProjectEmpty = true;
                    }
                } else {
                    this.hydrologyFormValidation.hydrologyProject = false;
                    this.hydrologyFormValidation.formErrors.hydrologyProject = '';
                    this.hydrologyFormValidation.hydrologyProjectEmpty = false;
                }
                await this.validationBlock("peak_flow", this.hydroProjectMetadata.peakFlow);
                break;
            case 'sideFillSlope':
                if (value === '' || value < 0.00 || value > 50.0) {
                    await MessageCenter.addNotificationFromCode('WDT_74');
                    this.designControlFormValidation.sideFillSlope = true;
                    this.designControlFormValidation.formErrors.sideFillSlope = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.sideFillSlope = false;
                    this.designControlFormValidation.formErrors.sideFillSlope = '';
                }
                break;
            case 'sideWidthLimit':
                if (value === '' || value < 0.00 || value > 100.0) {
                    await MessageCenter.addNotificationFromCode('WDT_75');
                    this.designControlFormValidation.sideWidthLimit = true;
                    this.designControlFormValidation.formErrors.sideWidthLimit = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.sideWidthLimit = false;
                    this.designControlFormValidation.formErrors.sideWidthLimit = '';
                }
                break;
            case 'bermTopWidth':
                if (value === '' || value < 0.00 || value > 50.0) {
                    await MessageCenter.addNotificationFromCode('WDT_76');
                    this.designControlFormValidation.bermTopWidth = true;
                    this.designControlFormValidation.formErrors.bermTopWidth = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.bermTopWidth = false;
                    this.designControlFormValidation.formErrors.bermTopWidth = '';
                }
                break;
            case 'bermBackSlope':
                if (value === '' || value < 2.00 || value > 20.0) {
                    await MessageCenter.addNotificationFromCode('WDT_77');
                    this.designControlFormValidation.bermBackSlope = true;
                    this.designControlFormValidation.formErrors.bermBackSlope = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.bermBackSlope = false;
                    this.designControlFormValidation.formErrors.bermBackSlope = '';
                }
                break;
            case 'startGradeLength':
                if (value === '' || value < 0.00 || value > 50) {
                    await MessageCenter.addNotificationFromCode('WDT_137');
                    this.designControlFormValidation.startGradeLength = true;
                    this.designControlFormValidation.formErrors.startGradeLength = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.startGradeLength = false;
                    this.designControlFormValidation.formErrors.startGradeLength = '';
                    if (this.originalStartGradeLength === undefined) {
                        this.originalStartGradeLength = value;
                    }
                    if (this.channelGradeLengthChanged) {
                        await this.updateWaterwayDesignControlSettings('startGradeLength', value);
                        if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                            waterwayDesignStore.channelStartGradeLengthChangedGlobal = true;
                        }
                        this.channelGradeLengthChanged = false;
                    }
                }
                break;
            case 'endGradeLength':
                if (value === '' || value < 0.00 || value > 50) {
                    await MessageCenter.addNotificationFromCode('WDT_137');
                    this.designControlFormValidation.endGradeLength = true;
                    this.designControlFormValidation.formErrors.endGradeLength = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else {
                    this.designControlFormValidation.endGradeLength = false;
                    this.designControlFormValidation.formErrors.endGradeLength = '';
                    if (this.originalEndGradeLength === undefined) {
                        this.originalEndGradeLength = value;
                    }
                    if (this.channelGradeLengthChanged) {
                        await this.updateWaterwayDesignControlSettings('endGradeLength', value);
                        if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                            waterwayDesignStore.channelEndGradeLengthChangedGlobal = true;
                        }
                        this.channelGradeLengthChanged = false;
                    }
                }
                break;
            case 'startGradeSlope':
                const grade = parseFloat(value);
                if (isNaN(grade) || grade < -5 || grade > 5) {
                    await MessageCenter.addErrorFromCode('WDT_138');
                    this.designControlFormValidation.startGradeSlope = true;
                    this.designControlFormValidation.formErrors.startGradeSlope = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                    return;
                }
                if (grade < 0) {
                    await MessageCenter.addWarningFromCode('WDT_139');
                }
                this.designControlFormValidation.startGradeSlope = false;
                this.designControlFormValidation.formErrors.startGradeSlope = '';
                await this.updateWaterwayDesignControlSettings('startGradeSlope', value);
                if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0 && this.channelSlopeChanged) {
                    waterwayDesignStore.channelStartGradeLengthChangedGlobal = true;
                    this.channelSlopeChanged = false;
                }
                break;
            case 'endGradeSlope':
                const endGrade = parseFloat(value); //
                if (isNaN(endGrade) || endGrade < -5 || endGrade > 5) {
                    await MessageCenter.addErrorFromCode('WDT_138');
                    this.designControlFormValidation.endGradeSlope = true;
                    this.designControlFormValidation.formErrors.endGradeSlope = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                    return;
                }
                if (endGrade < 0) {
                    await MessageCenter.addWarningFromCode('WDT_139');
                }
                this.designControlFormValidation.endGradeSlope = false;
                this.designControlFormValidation.formErrors.endGradeSlope = '';
                await this.updateWaterwayDesignControlSettings('endGradeSlope', value);
                if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0 && this.channelSlopeChanged) {
                    waterwayDesignStore.channelEndGradeLengthChangedGlobal = true;
                    this.channelSlopeChanged = false;
                }
                break;
            case 'freeBoard':
                if (value === '' || value < 0.00 || value > 10.0) {
                    await MessageCenter.addNotificationFromCode('WDT_41');
                    this.designControlFormValidation.freeBoard = true;
                    this.designControlFormValidation.formErrors.freeBoard = 'usa-input--error';
                    this.designControlFormValidation.hasError = true;
                } else if ((waterwayDesignStore.waterwayType === 'Lined Waterway' ||
                    waterwayDesignStore.currentWaterwayDesignElementTypeId === 19) &&
                    (value < 0.25 || value > 1.0)) {
                    await MessageCenter.addWarningFromCode('WDT_156');
                    this.designControlFormValidation.freeBoard = false;
                    this.designControlFormValidation.formErrors.freeBoard = '';
                } else {
                    this.designControlFormValidation.freeBoard = false;
                    this.designControlFormValidation.formErrors.freeBoard = '';
                }
                break;
            case 'liningMaterial':
                if (!this.showLiningMaterialConfirmation[0]) {
                    if (value === '' || value === undefined) {
                        await MessageCenter.addNotificationFromCode('Common_09', undefined, 'Lining Material')
                        this.liningMaterialFormValidation.liningMaterialOption = true;
                        this.liningMaterialFormValidation.formErrors.liningMaterialOption = 'usa-input--error';
                        // this.selectedLiningMaterialFormValidation.hasError = true;
                        // this.selectedLiningMaterialFormValidation.selectedLiningMaterialEmpty = true;
                    } else {
                        this.liningMaterialFormValidation.liningMaterialOption = false;
                        this.liningMaterialFormValidation.formErrors.liningMaterialOption = '';
                        // this.selectedLiningMaterialFormValidation.selectedLiningMaterialEmpty = false;
                    }
                }
                break;
            case 'LiningMaterialName':
                if (value === '' || value === undefined) {
                    await MessageCenter.addNotificationFromCode('Common_09', undefined, 'Lining Material Name')
                    this.liningMaterialFormValidation.manualEntryMaterialName = true;
                    this.liningMaterialFormValidation.formErrors.manualEntryMaterialName = 'usa-input--error';
                } else {
                    this.liningMaterialFormValidation.manualEntryMaterialName = false;
                    this.liningMaterialFormValidation.formErrors.manualEntryMaterialName = '';
                }
                break;
            case 'manning':
                if (value === '' || val < 0.0001 || val > 1.0000) {
                    await MessageCenter.addNotificationFromCode('Formula_02');
                    this.liningMaterialFormValidation.manualEntryManning = true;
                    this.liningMaterialFormValidation.formErrors.manualEntryManning = 'usa-input--error';
                } else {
                    this.liningMaterialFormValidation.manualEntryManning = false;
                    this.liningMaterialFormValidation.formErrors.manualEntryManning = '';
                }
                break;
            case 'thickness':
                if (value === '' || value < 0.1 || value > 30) {
                    await MessageCenter.addNotificationFromCode('WDT_149');
                    this.liningMaterialFormValidation.manualEntryThickness = true;
                    this.liningMaterialFormValidation.formErrors.manualEntryThickness = 'usa-input--error';
                } else {
                    this.liningMaterialFormValidation.manualEntryThickness = false;
                    this.liningMaterialFormValidation.formErrors.manualEntryThickness = '';
                }
                break;
            default:
                break;
        }
        this.updateAlignmentValidation();
        this.updateDesignControlValidation();
        this.updateHydrologyFormValidation();
        // this.updateSelectedLiningMaterialFormValidation()
    }
    @action.bound async validationBlockOnLoad(name, value) {
        switch (name) {
            case 'waterway_name':
                if (value === '') {
                    this.infoFormValidation.waterway_name = true;
                    this.infoFormValidation.formErrors.waterway_name = 'usa-input--error';
                    this.infoFormValidation.hasError = true;
                } else {
                    this.infoFormValidation.waterway_name = false;
                    this.infoFormValidation.formErrors.waterway_name = '';
                }
                break;

            case 'alignment':
                if (value === "" || value === 0 || value === undefined) {
                    this.alignmentFormValidation.alignment = true;
                    this.alignmentFormValidation.formErrors.alignment = 'usa-input--error';
                    this.alignmentFormValidation.hasError = true;
                    this.alignmentFormValidation.alignmentEmpty = true;

                } else {
                    this.alignmentFormValidation.alignment = false;
                    this.alignmentFormValidation.formErrors.alignment = '';
                    this.alignmentFormValidation.alignmentEmpty = false;
                    if (this.selectedAlignmentId) this.displayAlignment(this.selectedAlignmentId);
                }
                break;

            case 'peak_flow':
                if (value === "" || value === undefined || value < 0.01 || value > 1000) {
                    this.hydrologyFormValidation.peak_flow = true;
                    this.hydrologyFormValidation.formErrors.peak_flow = 'usa-input--error';
                    this.hydrologyFormValidation.hasError = true;
                    if (value === '' || value === undefined) {
                        this.hydrologyFormValidation.peakFlowEmpty = true;
                    }
                } else {
                    this.hydrologyFormValidation.peak_flow = false;
                    this.hydrologyFormValidation.formErrors.peak_flow = '';
                    this.hydrologyFormValidation.peakFlowEmpty = false;
                }
                break;

            case 'hydrology_project':
                if (value === "" || value === 0 || value === undefined) {
                    this.hydrologyFormValidation.hydrologyProject = true;
                    this.hydrologyFormValidation.formErrors.hydrologyProject = 'usa-input--error';
                    this.hydrologyFormValidation.hasError = true;
                    if (value === '' || value === undefined) {
                        this.hydrologyFormValidation.hydrologyProjectEmpty = true;
                    }
                } else {
                    this.hydrologyFormValidation.hydrologyProject = false;
                    this.hydrologyFormValidation.formErrors.hydrologyProject = '';
                    this.hydrologyFormValidation.hydrologyProjectEmpty = false;
                }
                break;
        }
    }
    @action.bound async validateInputOnLoad(name, value) {
        this.validationBlockOnLoad(name, value);
        this.updateSaveAndProceedButtonFlag();
    }

    @action.bound async validateInputField(e) {
        const { name, value } = e.target;
        await this.validateInput(name, value.trim());
    }

    @action.bound async validateInput(name, value) {
        await this.validationBlock(name, value);
        this.updateSaveButtonsFlags();
    }

    @action.bound async validateLinedMaterialInput(name, value) {
        await this.validateInput(name, value)
    }

    @action.bound updateHydrologyFormValidation() {
        this.hydrologyFormValidation.hasError =
            this.hydrologyFormValidation.hydrologyProject ||
            this.hydrologyFormValidation.initialQFraction ||
            this.hydrologyFormValidation.peak_flow;

        this.hydrologyFormValidation.canSave = !this.hydrologyFormValidation.initialQFraction &&
            this.hydrologyFormValidation.hydrologyProjectEmpty === this.hydrologyFormValidation.hydrologyProject &&
            this.hydrologyFormValidation.peakFlowEmpty === this.hydrologyFormValidation.peak_flow;
    }
    @action.bound updateDesignControlValidation() {
        this.designControlFormValidation.hasError =
            this.designControlFormValidation.sideFillSlope ||
            this.designControlFormValidation.sideWidthLimit ||
            this.designControlFormValidation.bermTopWidth ||
            this.designControlFormValidation.bermBackSlope ||
            this.designControlFormValidation.startGradeLength ||
            this.designControlFormValidation.startGradeSlope ||
            this.designControlFormValidation.endGradeLength ||
            this.designControlFormValidation.endGradeSlope ||
            this.designControlFormValidation.freeBoard ||
            this.designControlFormValidation.channelControl ||
            this.designControlFormValidation.channelEndControl;
    }
    @action.bound updateAlignmentValidation() {
        this.alignmentFormValidation.hasError =
            this.alignmentFormValidation.alignment ||
            this.alignmentFormValidation.seedingBufferWidth;
        this.alignmentFormValidation.canSave =
            (this.alignmentFormValidation.alignmentEmpty || this.alignmentFormValidation.alignmentEmpty === this.alignmentFormValidation.alignment) &&
            !this.alignmentFormValidation.seedingBufferWidth;
    }

    // return true -> validated; return false -> invalid
    @action.bound updateLiningMaterialValidation() {
        const isLinedWaterway = waterwayDesignStore.waterwayType === 'Lined Waterway' || waterwayDesignStore.currentWaterwayDesignElementTypeId === 19;
        if (isLinedWaterway) {
            if (this.liningMaterailForm.disabledManual) {
                return this.liningMaterailForm.selectedLiningMaterail !== '';
            } else {
                const formErrors = this.liningMaterialFormValidation.formErrors.manualEntryMaterialName === '' &&
                    this.liningMaterialFormValidation.formErrors.manualEntryManning === '' &&
                    this.liningMaterialFormValidation.formErrors.manualEntryThickness === '';
                const formValidation = !this.liningMaterialFormValidation.manualEntryMaterialName &&
                    !this.liningMaterialFormValidation.manualEntryManning &&
                    !this.liningMaterialFormValidation.manualEntryThickness
                return formErrors && formValidation
            }
        }
        return true;
    }

    // include save and save&proceed buttons
    @action.bound updateSaveButtonsFlags() {
        if (this.designControlFormValidation.hasError ||
            this.hydrologyFormValidation.hasError ||
            this.alignmentFormValidation.hasError ||
            !this.updateLiningMaterialValidation()
        ) {
            if (!this.designControlFormValidation.hasError &&
                this.hydrologyFormValidation.canSave &&
                this.alignmentFormValidation.canSave &&
                this.minimumRequiredInputs) {
                designStore.disableSaveButtonInputPage = false;
            } else {
                designStore.disableSaveButtonInputPage = true;
            }
            designStore.disableSaveProceedButtonInputPage = true;
            waterwayDesignStore.requiredInputsValidated = false;
        }
        else {
            if (this.minimumRequiredInputs) {
                designStore.disableSaveButtonInputPage = false;
            }
            if (this.validateRequiredInputs) {
                designStore.disableSaveProceedButtonInputPage = false;
                waterwayDesignStore.requiredInputsValidated = true;
            }
        }
    }

    @action.bound updateSaveAndProceedButtonFlag() {
        if (this.designControlFormValidation.hasError ||
            this.hydrologyFormValidation.hasError ||
            this.alignmentFormValidation.hasError ||
            !this.updateLiningMaterialValidation()) {
            designStore.disableSaveProceedButtonInputPage = true;
            waterwayDesignStore.requiredInputsValidated = false;
        }
        else {
            if (this.validateRequiredInputs) {
                waterwayDesignStore.requiredInputsValidated = true;
            }
        }
    }

    @action.bound handleDesignControlFormFocus(event) {
        const { value, name } = event.target;
        if (name == "startGradeLength") {
            this.originalStartLength = value;
        } else if (name == 'endGradeLength') {
            this.originalEndLength = value;
        }
    }

    @action.bound selectChannelType(event) {
        const { name } = event.target;
        if (name === 'parabolic-wdt') {
            this.designControlForm.channelControl = 'PARABOLIC';
        } else if (name === 'trapezoid-wdt') {
            this.designControlForm.channelControl = 'TRAPEZOIDAL';
        }
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        this.updateSaveButtonsFlags();
    }
    get trapezoidControlWDT(): boolean {
        return this.designControlForm.channelControl === 'TRAPEZOIDAL';
    }
    get parabolicControlWDT(): boolean {
        return this.designControlForm.channelControl === 'PARABOLIC';
    }
    @action.bound async selectChannelEndType(event) {
        const { name } = event.target;
        const { uiState, alignedDesignElementId } = waterwayDesignStore;

        let startGradeLength, startGradeSlope, endGradeLength, endGradeSlope;
        if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
            startGradeLength = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength;
            startGradeSlope = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade;
            endGradeLength = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength;
            endGradeSlope = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade;

            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength = startGradeLength;
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade = startGradeSlope;
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength = endGradeLength;
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade = endGradeSlope;
        }

        const isWaterwayInputState = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0;
        const isReachDesignState = ['ReachDesignCalculate', 'ReachDesignSave', 'ReachDesignSurface'].includes(uiState);

        const updateWaterwayDesignControlSettings = async (alignedElementDesignParametersId, channelEndsControlType, startSlopeDistance, endSlopeDistance, startSlopePercentage, endSlopePercentage, designControlSyncDisabled) => {
            try {
                const response = await WaterwayDesignToolsController.updateWaterwayDesignControlSettingsUsingPOST({
                    alignedElementDesignParametersId,
                    channelEndsControlType,
                    endSlopeDistance,
                    endSlopePercentage,
                    startSlopeDistance,
                    startSlopePercentage,
                    designControlSyncDisabled: true
                });

                this.designControlFormValidation.startGradeSlope = false;
                this.designControlFormValidation.formErrors.startGradeSlope = '';
                this.designControlFormValidation.endGradeSlope = false;
                this.designControlFormValidation.formErrors.endGradeSlope = '';
                this.designControlFormValidation.hasError = false;

                return response;
            } catch (error) {
            }
        };

        if (name === 'channel_end_length') {
            this.designControlForm.channelEndControl = 0;

            if (isWaterwayInputState) {
                this.designControlForm.startGradeSlope = 0;
                this.designControlForm.endGradeSlope = 0;
            }

            if (isReachDesignState || waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                const response = await updateWaterwayDesignControlSettings(alignedDesignElementId, 1, startGradeLength, endGradeLength, startGradeSlope, endGradeSlope, true);
                if (response && response.data) {
                    if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                        const startSlopeDistance = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                        const endSlopeDistance = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                        const startSlopePercentage = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                        const endSlopePercentage = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;

                        if (startSlopeDistance < 0 || startSlopeDistance > 50) {
                            await MessageCenter.addErrorFromCode('WDT_137');
                            this.designControlFormValidation.startGradeLength = true;
                            this.designControlFormValidation.formErrors.startGradeLength = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (endSlopeDistance < 0 || endSlopeDistance > 50) {
                            await MessageCenter.addErrorFromCode('WDT_137');
                            this.designControlFormValidation.endGradeLength = true;
                            this.designControlFormValidation.formErrors.endGradeLength = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (startSlopePercentage < -5 || startSlopePercentage > 5) {
                            await MessageCenter.addErrorFromCode('WDT_138');
                            this.designControlFormValidation.startGradeSlope = true;
                            this.designControlFormValidation.formErrors.startGradeSlope = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (endSlopePercentage < -5 || endSlopePercentage > 5) {
                            await MessageCenter.addErrorFromCode('WDT_138');
                            this.designControlFormValidation.endGradeSlope = true;
                            this.designControlFormValidation.formErrors.endGradeSlope = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                        this.designControlForm.startGradeLength = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                        this.designControlForm.endGradeLength = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                    }
                }
                if (response && response.data) {
                    if (response.data.startSlopeDistance !== undefined && this.originalStartGradeLength !== undefined &&
                        Math.abs(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength = this.originalStartGradeLength) > 0.1) {
                        await MessageCenter.addNotificationFromCode('Common_25', undefined, 'Start Length');
                    }
                    if (response.data.endSlopeDistance !== undefined && this.originalEndGradeLength !== undefined &&
                        Math.abs(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength - this.originalEndGradeLength) > 0.1) {
                        await MessageCenter.addNotificationFromCode('Common_25', undefined, 'End Length');
                    }
                }
                this.originalStartGradeLength = undefined;
                this.originalEndGradeLength = undefined;
            }

        } else if (name === 'channel_end_slope') {
            this.designControlForm.channelEndControl = 1;

            if (isWaterwayInputState) {
                this.designControlForm.startGradeLength = 0;
                this.designControlForm.endGradeLength = 0;
            }
            if (isReachDesignState || waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                const response = await updateWaterwayDesignControlSettings(alignedDesignElementId, 0, startGradeLength, endGradeLength, startGradeSlope, endGradeSlope, true);
                if (response && response.data) {
                    if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                        const startSlopeDistance = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                        const endSlopeDistance = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                        const startSlopePercentage = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                        const endSlopePercentage = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;

                        if (startSlopeDistance < 0 || startSlopeDistance > 50) {
                            await MessageCenter.addErrorFromCode('WDT_137');
                            this.designControlFormValidation.startGradeLength = true;
                            this.designControlFormValidation.formErrors.startGradeLength = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (endSlopeDistance < 0 || endSlopeDistance > 50) {
                            await MessageCenter.addErrorFromCode('WDT_137');
                            this.designControlFormValidation.endGradeLength = true;
                            this.designControlFormValidation.formErrors.endGradeLength = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (startSlopePercentage < -5 || startSlopePercentage > 5) {
                            await MessageCenter.addErrorFromCode('WDT_138');
                            this.designControlFormValidation.startGradeSlope = true;
                            this.designControlFormValidation.formErrors.startGradeSlope = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }

                        if (endSlopePercentage < -5 || endSlopePercentage > 5) {
                            await MessageCenter.addErrorFromCode('WDT_138');
                            this.designControlFormValidation.endGradeSlope = true;
                            this.designControlFormValidation.formErrors.endGradeSlope = 'usa-input--error';
                            this.designControlFormValidation.hasError = true;
                        }
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;
                        this.designControlForm.startGradeSlope = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                        this.designControlForm.endGradeSlope = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;
                    }

                }
            }
        }
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        this.updateSaveButtonsFlags();
    }
    get channelEndLengthControl(): boolean {
        return this.designControlForm.channelEndControl === 0;
    }
    get channelEndSlopeControl(): boolean {
        return this.designControlForm.channelEndControl === 1;
    }
    @action.bound async selectSeedingBufferOption(event) {
        const { name } = event.target;
        if (name === 'alignment-Channel-Border') {
            this.designControlForm.seedingBufferOption = 1;
        } else if (name === 'alignment-water-level') {
            this.designControlForm.seedingBufferOption = 2;
        }
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        this.updateSaveButtonsFlags();
    }

    get alignmentWaterLevel(): boolean {
        waterwayDesignStore.seedingBufferOption = this.designControlForm.seedingBufferOption;
        return this.designControlForm.seedingBufferOption === 2;
    }
    get alignmentChannelBorder(): boolean {
        waterwayDesignStore.seedingBufferOption = this.designControlForm.seedingBufferOption;
        return this.designControlForm.seedingBufferOption === 1;
    }

    @action.bound handleInfoFormChange(event) {
        const { name, value } = event.target;
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        // if(!this.hydrologyFormValidation.hasError && this.waterwayName.length > 0){
        //     designStore.disableSaveButtonInputPage = false;
        // }
        // if(!this.hydrologyFormValidation.hasError && this.waterwayName.length > 0 && waterwayDesignStore.requiredInputsValidated){
        //     designStore.disableSaveProceedButtonInputPage = false;
        // }
        switch (name) {
            case 'waterway_name':
                this.waterwayName = value;
                waterwayDesignStore.waterwayName = value;
                if (value.trim().length <= 0) {
                    designStore.disableSaveButtonInputPage = true;
                    designStore.disableSaveProceedButtonInputPage = true;
                }
                break;
            case 'construction_benchmark':
                this.constructionBenchmark = value;
                break;
            case 'construction_elevation':
                const parsedValue = parseFloat(parseFloat(value).toFixed(2));
                if (value < 0) { this.constructionElevation = 0 }
                else { this.constructionElevation = parsedValue };
                break;
            case 'benchmark_description':
                this.benchmarkDescription = value;
                break;
            case 'spoil_disposal':
                this.spoilDisposal = value;
                break;
            // Used handleLiningMaterialChange() dirrectly 
            // case 'waterwayMaterial':
            //     this.handleLiningMaterialChange(event)
            //     break;
            default:
                break;
        }
    }

    @action.bound openLiningMaterialChangeConfirmation = (event) => {
        const { value, name } = event.target;
        if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
            this.showLiningMaterialConfirmation = [true, name, value];
        } else {
            this.handleLiningMaterialOnChange(event);
        }

    };

    @action.bound handleLiningMaterialOnChange = (event) => {
        const { value, name } = event.target;
        switch (name) {
            case 'liningMaterial':
                this.liningMaterailForm.selectedLiningMaterail = value;
                if (value === '') {
                    this.liningMaterailForm.manning = 0;
                    this.liningMaterailForm.thickness = 0;
                }
                else {
                    this.liningMaterailForm.manning = this.liningMaterialOptions.filter(e => e.value === this.liningMaterailForm.selectedLiningMaterail)[0].manning!;
                    this.liningMaterailForm.thickness = this.liningMaterialOptions.filter(e => e.value === this.liningMaterailForm.selectedLiningMaterail)[0].liningThickness!;
                }
                if (value !== 'Manual Entry') {
                    this.liningMaterailForm.disabledManual = true;
                } else {
                    this.resetLiningMaterialManualEntry();
                    this.liningMaterailForm.disabledManual = false;
                }
                break;
            case 'LiningMaterialName':
                this.liningMaterailForm.manualEntryLiningMaterailName = value;
                break
            case 'manning':
                if (value.length > 7) { return }
                else this.liningMaterailForm.manning = value;
                break
            case 'thickness':
                this.liningMaterailForm.thickness = value;
                break
            default:
                break
        }
    }

    @action.bound handleAlignmentFormChange(event) {
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        const { name, value } = event.target;
        switch (name) {
            case 'alignment':
                this.selectedAlignmentId = value;
                // await this.validateInput(name, value)
                break;
            case 'seeding_buffer_width':
                const parsedValue = parseFloat(parseFloat(value).toFixed(2));
                if (value < 0) { this.seedingBufferWidth = 0 }
                else { this.seedingBufferWidth = parsedValue };
                break;
        }
    }
    @action.bound async handleHydrologyFormChange(event) {
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        const { name, value } = event.target;
        // designStore.disableSaveProceedButtonInputPage = true;
        switch (name) {
            case 'hydrology_frequency':
                this.hydrologyForm.hydrologyFrequencySelection = value;
                break;
            case 'hydrology_project':
                this.resetHydroProjectMetadata();
                this.hydrologyForm.hydrologyProjectSlection = value;
                // await this.validateInput(name, value);
                // await this.validateInput("peak_flow", this.hydroProjectMetadata.peakFlow);
                const reqIndex = this.HydroByAlignmentAoiData.findIndex(item => item.projectUuid === value)
                if (reqIndex === -1) {
                    waterwayDesignStore.selectedHydroProjectName = 'User Defined';
                } else {
                    waterwayDesignStore.selectedHydroProjectName = this.HydroByAlignmentAoiData[reqIndex].projectTitle;
                }
                break;
            case 'peak_flow':
                const parsedValuePeakFlow = parseFloat(parseFloat(value).toFixed(2));
                if (value === '') {
                    this.hydroProjectMetadata.peakFlow = undefined;
                }
                else if (Number.isNaN(parsedValuePeakFlow) && !Number.isNaN(parseFloat(parseFloat('0' + value).toFixed(2)))) {
                    // allows numerical symbols like "." in case the user just types ".01"
                    this.hydroProjectMetadata.peakFlow = parseFloat(parseFloat('0' + value).toFixed(2));
                }
                else {
                    this.hydroProjectMetadata.peakFlow = parsedValuePeakFlow;
                }

                if (value < 0) {
                    this.hydroProjectMetadata.peakFlow = 0
                }
                else {
                    if (this.hydroProjectMetadata.peakFlow || this.hydroProjectMetadata.peakFlow === 0) {
                        if (this.hydrologyForm.hydrologyProjectSlection !== this.hydrologyProjectOptions[0].value as string) {
                            this.resetHydroProjectMetadata();
                            this.hydrologyForm.hydrologyProjectSlection = this.hydrologyProjectOptions[0].value as string
                            this.hydrologyFormValidation.hydrologyProject = false;
                            this.hydrologyFormValidation.formErrors.hydrologyProject = '';
                            this.hydrologyFormValidation.hydrologyProjectEmpty = false;
                            this.hydroProjectMetadata.peakFlow = parsedValuePeakFlow;

                        }
                    } else {
                        this.hydrologyForm.hydrologyProjectSlection = "";
                    }
                }
                // await this.validateInput("hydrology_project", this.hydrologyForm.hydrologyProjectSlection);
                break;
            case 'initialQFraction':
                const parsedValueInitialQFraction = parseFloat(parseFloat(value).toFixed(2));
                if (value < 0) { this.hydrologyForm.initialQFraction = 0 }
                else { this.hydrologyForm.initialQFraction = parsedValueInitialQFraction };
                break;
        }
    }
    @action.bound resetHydroProjectMetadata() {
        this.hydroProjectMetadata.county = ""
        this.hydroProjectMetadata.drainageArea = undefined
        this.hydroProjectMetadata.frequencyInYrs = undefined
        this.hydroProjectMetadata.lastChangedBy = ""
        this.hydroProjectMetadata.lastChangedDate = ""
        this.hydroProjectMetadata.peakFlow = undefined
        this.hydroProjectMetadata.projectOwner = ""
        this.hydroProjectMetadata.projectStatus = ""
        this.hydroProjectMetadata.projectUuid = ""
        this.hydroProjectMetadata.runOff = undefined
        this.hydroProjectMetadata.state = ""
        this.hydroProjectMetadata.waterShedUrl = ""
        this.hydroProjectMetadata.watershedCentroid = undefined
        this.hydroProjectMetadata.watershedLength = undefined
        this.hydroProjectMetadata.watershedSlope = undefined
        this.hydroProjectMetadata.weightedCurveNumber = undefined

    }
    @action.bound async handleDesignControlFormChange(event) {
        waterwayDesignStore.waterwayInputsPageInputsChange = true;
        waterwayDesignStore.startGradeNegative = false;
        waterwayDesignStore.endGradeNegative = false;
        const { name, value } = event.target;

        let parsedValue;
        if (value === '-' || value === '.' || value === '-.' || (value.toString().search(/[^\d\.-]|[e]/) === -1 && !isNaN(value))) {
            parsedValue = value;
        } else {
            parsedValue = parseFloat(value);
            if (isNaN(parsedValue)) {
                parsedValue = '';
            } else {
                parsedValue = parseFloat(parsedValue.toFixed(2));
            }
        }
        this.designControlForm[name] = parsedValue;
        switch (name) {
            case 'sideFillSlope':
                if (value < 0) { this.designControlForm.sideFillSlope = 0 }
                else { this.designControlForm.sideFillSlope = parseFloat(parseFloat(value).toFixed(2)) };
                break;
            case 'sideWidthLimit':
                if (value < 0) { this.designControlForm.sideWidthLimit = 0 }
                else { this.designControlForm.sideWidthLimit = parseFloat(parseFloat(value).toFixed(2)) };
                break;
            case 'bermTopWidth':
                if (value < 0) { this.designControlForm.bermTopWidth = 0 }
                else { this.designControlForm.bermTopWidth = parseFloat(parseFloat(value).toFixed(2)) };
                break;
            case 'bermBackSlope':
                if (value < 0) { this.designControlForm.bermBackSlope = 0 }
                else { this.designControlForm.bermBackSlope = parseFloat(parseFloat(value).toFixed(2)) };
                break;
            case 'startGradeLength':
                if (value < 0) { this.designControlForm.startGradeLength = 0 }
                else {
                    this.designControlForm.startGradeLength = parseFloat(parseFloat(value).toFixed(1))
                    this.channelGradeLengthChanged = true;
                    if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength = parseFloat(parseFloat(value).toFixed(2));
                    }
                }
                this.selectChannelEndType(event)
                break;
            case 'endGradeLength':
                if (value < 0) { this.designControlForm.endGradeLength = 0 }
                else {
                    this.designControlForm.endGradeLength = parseFloat(parseFloat(value).toFixed(1));
                    this.channelGradeLengthChanged = true;
                    if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                        waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength = parseFloat(parseFloat(value).toFixed(2));
                    }
                }
                this.selectChannelEndType(event)
                break;
            case 'startGradeSlope':
                this.designControlForm.startGradeSlope = parsedValue;
                this.channelSlopeChanged = true;
                if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade = parsedValue;
                }
                this.selectChannelEndType(event);
                break;
            case 'endGradeSlope':
                this.designControlForm.endGradeSlope = parsedValue;
                this.channelSlopeChanged = true;
                if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade = parsedValue;
                }
                this.selectChannelEndType(event);
                break;
            case 'freeBoard':
                if (value < 0) { this.designControlForm.freeBoard = 0 }
                else { this.designControlForm.freeBoard = parseFloat(parseFloat(value).toFixed(2)) };
                waterwayDesignStore.globalFreeBoard = this.designControlForm.freeBoard;
                break;
        }
    }
    @action.bound async updateWaterwayDesignControlSettings(fieldName, fieldValue) {
        waterwayDesignStore.startGradeNegative = false;
        waterwayDesignStore.endGradeNegative = false;
        this.isUpdating = true;
        const { uiState, alignedDesignElementId } = waterwayDesignStore;
        const isReachDesignState = ['ReachDesignCalculate', 'ReachDesignSave', 'ReachDesignSurface'].includes(uiState);
        if (!isReachDesignState && !waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length) {
            this.isUpdating = false;
            return;
        }

        const alignedElementDesignParametersId = alignedDesignElementId;
        let startSlopeDistance = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength);
        let endSlopeDistance = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength);
        let startSlopePercentage = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade);
        let endSlopePercentage = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade);
        const designControlSyncDisabled = true;
        let channelEndsControlType;
        switch (fieldName) {
            case 'startGradeLength':
                startSlopeDistance = Number(fieldValue);
                channelEndsControlType = 0;
                break;
            case 'endGradeLength':
                endSlopeDistance = Number(fieldValue);
                channelEndsControlType = 0;
                break;
            case 'startGradeSlope':
                startSlopePercentage = Number(fieldValue);
                channelEndsControlType = 1;
                break;
            case 'endGradeSlope':
                endSlopePercentage = Number(fieldValue);
                channelEndsControlType = 1;
                break;
        }
        try {
            const response = await WaterwayDesignToolsController.updateWaterwayDesignControlSettingsUsingPOST({
                alignedElementDesignParametersId,
                channelEndsControlType,
                endSlopeDistance,
                endSlopePercentage,
                startSlopeDistance,
                startSlopePercentage,
                designControlSyncDisabled
            });
            if (response && response.data && waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                if (fieldName === 'startGradeLength' || fieldName === 'startGradeSlope') {
                    const startSlopeDistance = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                    const startSlopePercentage = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;

                    if (startSlopeDistance < 0 || startSlopeDistance > 50) {
                        await MessageCenter.addErrorFromCode('WDT_137');
                        this.designControlFormValidation.startGradeLength = true;
                        this.designControlFormValidation.formErrors.startGradeLength = 'usa-input--error';
                        this.designControlFormValidation.hasError = true;
                    } else {
                        this.designControlFormValidation.startGradeLength = false;
                        this.designControlFormValidation.formErrors.startGradeLength = '';
                        this.designControlFormValidation.hasError = false;

                    }

                    if (startSlopePercentage < -5 || startSlopePercentage > 5) {
                        await MessageCenter.addErrorFromCode('WDT_138');
                        this.designControlFormValidation.startGradeSlope = true;
                        this.designControlFormValidation.formErrors.startGradeSlope = 'usa-input--error';
                        this.designControlFormValidation.hasError = true;
                    } else {
                        this.designControlFormValidation.startGradeSlope = false;
                        this.designControlFormValidation.formErrors.startGradeSlope = '';
                        this.designControlFormValidation.hasError = false;

                    }
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                    this.designControlForm.startGradeLength = response.data.startSlopeDistance !== undefined ? parseFloat(response.data.startSlopeDistance.toFixed(1)) : 0;
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                    this.designControlForm.startGradeSlope = response.data.startSlopePercentage !== undefined ? parseFloat(response.data.startSlopePercentage.toFixed(2)) : 0;
                }
                if (fieldName === 'endGradeLength' || fieldName === 'endGradeSlope') {
                    const endSlopeDistance = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                    const endSlopePercentage = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;

                    if (endSlopeDistance < 0 || endSlopeDistance > 50) {
                        await MessageCenter.addErrorFromCode('WDT_137');
                        this.designControlFormValidation.endGradeLength = true;
                        this.designControlFormValidation.formErrors.endGradeLength = 'usa-input--error';
                        this.designControlFormValidation.hasError = true;
                    } else {
                        this.designControlFormValidation.endGradeLength = false;
                        this.designControlFormValidation.formErrors.endGradeLength = '';
                        this.designControlFormValidation.hasError = false;
                    }

                    if (endSlopePercentage < -5 || endSlopePercentage > 5) {
                        await MessageCenter.addErrorFromCode('WDT_138');
                        this.designControlFormValidation.endGradeSlope = true;
                        this.designControlFormValidation.formErrors.endGradeSlope = 'usa-input--error';
                        this.designControlFormValidation.hasError = true;
                    } else {
                        this.designControlFormValidation.endGradeSlope = false;
                        this.designControlFormValidation.formErrors.endGradeSlope = '';
                        this.designControlFormValidation.hasError = false;
                    }
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                    this.designControlForm.endGradeLength = response.data.endSlopeDistance !== undefined ? parseFloat(response.data.endSlopeDistance.toFixed(1)) : 0;
                    waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;
                    this.designControlForm.endGradeSlope = response.data.endSlopePercentage !== undefined ? parseFloat(response.data.endSlopePercentage.toFixed(2)) : 0;

                }
            }
        } catch (error) {
            if (fieldName === 'startGradeSlope') {
                await MessageCenter.addNotificationFromCode('WDT_135');
                this.designControlFormValidation.startGradeSlope = true;
                this.designControlFormValidation.formErrors.startGradeSlope = 'usa-input--error';
                this.designControlFormValidation.hasError = true;
            } else if (fieldName === 'endGradeSlope') {
                await MessageCenter.addNotificationFromCode('WDT_135');
                this.designControlFormValidation.endGradeSlope = true;
                this.designControlFormValidation.formErrors.endGradeSlope = 'usa-input--error';
                this.designControlFormValidation.hasError = true;
            }
        }
        this.tableStore.checkSlopeDirection(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations);
        this.isUpdating = false;
    }
    @action.bound onClickInformationToggle = (title) => {
        this.headerTitle = title
        this.onClickInformation = !this.onClickInformation
    }
    @action.bound onClickMetaDataToggle = (title) => {
        this.onClickMetaData = !this.onClickMetaData
        this.getHydroProjectMetadata();
    }
    @action.bound resetHydrology = () => {
        this.hydrologyForm.hydrologyProjectSlection = "";
        this.hydrologyForm.hydrologyFrequencySelection = '10 year';
        this.hydrologyForm.initialQFraction = 100;
        this.resetHydroProjectMetadata();
    }

    @action.bound async getAllAlignments() {
        const sessionId = designStore.projectsStore.currentSessionId
        const alignmentList: ISelection[] = []
        waterwayDesignStore.checkAlignmentList = false

        try {
            const response = await DesignElementController.getAllDesignElementsBySessionAndTypeUsingGET(sessionId, "Alignment");
            if (response.data.length > 0) {
                const data = response.data
                for (const item of data) {
                    alignmentList.push({
                        name: item.designElementName!,
                        value: item.designElementId!,
                        optionDisabled: item.flagUpToDate!,
                    })
                }
                if (this.selectedAlignmentId == 0) {
                    waterwayDesignStore.checkAlignmentList = true;
                }
                this.alignmentOptions = alignmentList
            } else {

                waterwayDesignStore.checkAlignmentList = true
                await MessageCenter.addNotificationFromCode('WDT_64')

            }
        } catch (error) {
            // console.error('getAllDesignElementsBySessionAndTypeUsingGET error:', error);
        }
    }

    get minimumRequiredInputs() {
        if (this.waterwayName.trim().length > 0 || waterwayDesignStore.waterwayName.trim().length > 0) {
            return true
        }
        return false
    }

    get validateRequiredInputs() {
        const isLinedWaterway = waterwayDesignStore.waterwayType === 'Lined Waterway' ||
            waterwayDesignStore.currentWaterwayDesignElementTypeId === 19;

        if ((this.waterwayName.trim().length > 0 || waterwayDesignStore.waterwayName.trim().length > 0) &&
            this.selectedAlignmentId &&
            this.hydroProjectMetadata.peakFlow &&
            this.hydrologyForm.hydrologyProjectSlection &&
            (!isLinedWaterway || this.liningMaterailForm.selectedLiningMaterail !== "")) {
            return true;
        }
        return false;
    }
    @action async validateReqInput() {
        await this.validateInput("waterway_name", this.waterwayName);
        await this.validateInput("alignment", this.selectedAlignmentId);
        await this.validateInput("peak_flow", this.hydroProjectMetadata.peakFlow);
        await this.validateInput("hydrology_project", this.hydrologyForm.hydrologyProjectSlection);
    }
    @action async validateReqInputOnLoad() {
        await this.validateInputOnLoad("waterway_name", this.waterwayName);
        await this.validateInputOnLoad("alignment", this.selectedAlignmentId);
        await this.validateInputOnLoad("peak_flow", this.hydroProjectMetadata.peakFlow);
        await this.validateInputOnLoad("hydrology_project", this.hydrologyForm.hydrologyProjectSlection);
    }

    @action.bound async saveDesignUiState(whichBtn?) {
        designStore.displayResultBanner = false;
        const payload: EftProjUserInputDto = this.createSaveDesignUiStatePayload(whichBtn);
        try {
            const response = await EftProjUserInputController.saveDesignUiStateUsingPOST(payload);
        } catch (err) {
            // console.error("saveDesignUiState error", err)
        }
    }

    @action.bound async checkAndUpdateUphillAlignment(responseData: AlignedElementDesignParamsResponseDTO) {
        if (responseData.alignmentId && responseData.alignmentId !== +this.selectedAlignmentId) {
            await this.getAllAlignments();
            this.selectedAlignmentId = responseData.alignmentId;
        }
    }
    @action.bound async getUiStateAndNotification() {
        await this.props.getNotificationStatus(); // update Notification status on the waterwayDesignStore
        if (waterwayDesignStore.aligmentChange === 2) {
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations = [];
        }
        await this.props.getDesignUiState();
    }
    @action.bound async handleSave(saveType?) {
        if (this.isUpdating) {
            setTimeout(() => this.handleSave(saveType), 100);
            return;
        }
        designStore.setLoader(" Save waterway inputs...");
        waterwayDesignStore.isLoading = true;
        waterwayDesignStore.renderWaterwayDesign = false;
        if (this.minimumRequiredInputs) {
            waterwayDesignStore.checkAlignmentList = false;
            try {
                const payload: AlignedElementDesignParamsRequestDTO = this.createSavePayload();
                const response = await WDTAPI.createOrUpdateAlignedElementDesignParamsUsingPOST(payload);
                if (response && response.data && response.data.status?.toLowerCase() === 'success') {
                    const data = response.data;
                    // call comments save with data.alignedElementDesignParamsId as designElementId
                    await this.waterwayCommentsVM.handleCommentSubmit(data.alignedElementDesignParamsId, data.alignedFeatureName);
                    waterwayDesignStore.alignedDesignElementId = data.alignedElementDesignParamsId!;

                    // handle line material:
                    if ((waterwayDesignStore.currentWaterwayDesignElementTypeId === 19 || waterwayDesignStore.waterwayType === 'Lined Waterway')) {
                        const lineMaterialResponse = await WaterwayDesignToolsController.saveLiningMaterialByAlignedDesignElementIDUsingPOST({
                            alignedElementDesignParamsId: waterwayDesignStore.alignedDesignElementId,
                            waterwayMaterial: `${this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? this.liningMaterailForm.manualEntryLiningMaterailName : this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                        });
                        if (lineMaterialResponse) {
                            if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
                                waterwayDesignStore.defaultLiningMaterialChanged[0] = true;
                            }
                            else {
                                waterwayDesignStore.defaultLiningMaterialChanged[0] = false;
                            }
                            waterwayDesignStore.defaultLiningMaterial = `${this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? this.liningMaterailForm.manualEntryLiningMaterailName : this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                        }

                    }

                    waterwayDesignStore.saveInputPayloadAndId(
                        payload,
                        data.alignedElementDesignParamsId,
                        data.alignedFeatureName,
                        this.designControlForm.channelControl,
                        this.designControlForm.startGradeLength,
                        this.designControlForm.endGradeLength,
                        this.hydroProjectMetadata.peakFlow,
                        this.designControlForm.sideFillSlope,
                        this.designControlForm.sideWidthLimit,
                        this.designControlForm.bermTopWidth,
                        this.designControlForm.bermBackSlope,
                        this.designControlForm.endGradeSlope,
                        this.designControlForm.startGradeSlope,
                        this.hydrologyForm.initialQFraction,
                        this.designControlForm.channelEndControl,
                        this.selectedAlignmentId,
                        this.seedingBufferWidth,
                        this.designControlForm.freeBoard,
                        this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? `${this.liningMaterailForm.manualEntryLiningMaterailName} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                            : `${this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                    );
                    waterwayDesignStore.waterwayDesignObject.peakFlow = this.hydroProjectMetadata.peakFlow ? this.hydroProjectMetadata.peakFlow : 0;

                    if (response.data.reversedAlignment && !this.hasWDT122Warning) {
                        await MessageCenter.addWarningFromCode('WDT_122');
                        this.hasWDT122Warning = true;
                    }
                    if (saveType === 'save_and_proceed' && this.validateRequiredInputs) {
                        await this.saveDesignUiState("save_and_proceed");
                        this.disableChannelType = true;
                        waterwayDesignStore.renderWaterwayDesign = true;
                        waterwayDesignStore.currentWorkflowStep = 'design-waterway';
                        await MessageCenter.addNotificationFromCode('WDT_71');
                        await this.getUiStateAndNotification();
                    } else {
                        // save Ui State SaveInputs
                        if (this.validateRequiredInputs) {
                            await MessageCenter.addNotificationFromCode('WDT_71');
                        }
                        else {
                            await MessageCenter.addNotificationFromCode('WDT_70');
                        }
                        await this.saveDesignUiState();
                        await this.getUiStateAndNotification();
                    }
                    await this.validateIfRedistruibuteRunoff();
                    await this.checkAndUpdateUphillAlignment(data);
                }
            }
            catch (e) {
                // console.error(e);
            }
            finally {
                waterwayDesignStore.waterwayInputsPageInputsChange = false;
            }

        }
        else {
            waterwayDesignStore.requiredInputsValidated = false;
            await MessageCenter.addNotificationFromCode('WDT_80');
        }
        this.updateSaveAndProceedButtonFlag();
        waterwayDesignStore.isLoading = false;
        designStore.setLoader("");
    }

    async updateLiningMaterialInBackend(newMaterial: string) {
        try {
            const payload = {
                alignedElementDesignParamsId: waterwayDesignStore.alignedDesignElementId,
                waterwayMaterial: newMaterial
            };
            await WaterwayDesignToolsController.saveLiningMaterialByAlignedDesignElementIDUsingPOST(payload);
        } catch (error) {
            MessageCenter.addError("An error occurred while saving the lining material. Please try again.");
        }
    }

    @action.bound async updateValuesFromUndoPEM() {
        let changed = false;
        if (this.designControlForm.startGradeLength !== waterwayDesignStore.waterwayDesignObject.startGradeLength) {
            this.designControlForm.startGradeLength = waterwayDesignStore.waterwayDesignObject.startGradeLength;
            this.designControlForm.startGradeSlope = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade;
            changed = true;
        }
        if (this.designControlForm.endGradeLength !== waterwayDesignStore.waterwayDesignObject.endGradeLength) {
            this.designControlForm.endGradeLength = waterwayDesignStore.waterwayDesignObject.endGradeLength;
            this.designControlForm.endGradeSlope = waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade;
            changed = true;
        }
        if (changed) {
            try {
                const payload: AlignedElementDesignParamsRequestDTO = this.createSavePayload();
                const response = await WDTAPI.createOrUpdateAlignedElementDesignParamsUsingPOST(payload);
                if (response && response.data && response.data.status?.toLowerCase() === 'success') {
                    const data = response.data;

                    waterwayDesignStore.saveInputPayloadAndId(
                        payload,
                        data.alignedElementDesignParamsId,
                        data.alignedFeatureName,
                        this.designControlForm.channelControl,
                        this.designControlForm.startGradeLength,
                        this.designControlForm.endGradeLength,
                        this.hydroProjectMetadata.peakFlow,
                        this.designControlForm.sideFillSlope,
                        this.designControlForm.sideWidthLimit,
                        this.designControlForm.bermTopWidth,
                        this.designControlForm.bermBackSlope,
                        this.designControlForm.endGradeSlope,
                        this.designControlForm.startGradeSlope,
                        this.hydrologyForm.initialQFraction,
                        this.designControlForm.channelEndControl,
                        this.selectedAlignmentId,
                        this.seedingBufferWidth,
                        this.designControlForm.freeBoard,
                        this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? `${this.liningMaterailForm.manualEntryLiningMaterailName} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                            : `${this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                    );
                }
            }
            catch (e) {
                // console.error(e);
            }
        }
    }

    @action.bound async displayAlignment(alignmentId: number) {
        const layersMap = new Map();
        if (gisModel.map) {
            gisModel.map.layers.forEach((lyr) => layersMap.set(lyr.id, lyr));
        };
        const designElementsDataArray: any = await getListOfDesignElements(alignmentId.toString());
        let layerId = '';
        designElementsDataArray.forEach((element: any) => {
            layerId = this.displaySingleAlignment(element, layersMap);
        });
        // want to keep the sketch layer on top
        await sleep(1000); // let it redraw
        if (this.mapView) {
            putStructureRepOnTop(this.mapView, layerId);
            putStructureRepOnTop(this.mapView, 'alignment_sketch');
        }
    }

    @action.bound displaySingleAlignment(element: any, layersMap: any): string {
        let layerId = '';
        const isDisplayed = this.removeOtherAlignments(element.designElementId, layersMap);
        if (isDisplayed) return layerId;
        else {
            if (element.json) {
                const jsonData = JSON.parse(element.json);
                layerId = `alignment${element.designElementId}`;
                DisplayAlignment(
                    gisModel.map,
                    jsonData,
                    element.designElementName,
                    layerId,
                    '',
                    appConfig.tempHardCodes.wkid
                );
            }
            return layerId;
        }
    };

    removeOtherAlignments(designElementId: number, layersMap: any): boolean {
        let isDisplayed: boolean = false;
        const alignmentRegex = /^alignment\d{5}$/;

        layersMap.forEach((lyr) => {
            if (lyr.id && lyr.id.startsWith('alignment')) {
                if (lyr.id === `alignment${designElementId}`) {
                    isDisplayed = true;
                } else if (alignmentRegex.test(lyr.id)) {
                    const alignmentGroupLayer = gisModel.map.findLayerById(lyr.id);
                    if (alignmentGroupLayer) {
                        const removedLayer = gisModel.map.remove(alignmentGroupLayer);
                        removedLayer.destroy();
                    };
                }
            }
        })

        return isDisplayed;
    }

    @action.bound async validateIfRedistruibuteRunoff() {
        if (waterwayDesignStore.hydrologyChange === 1 && waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
            await this.props.retriveFlowCalculationResults(waterwayDesignStore.waterwayDesignObject);
        }
    }
    // unused function 
    get hydrologyChange() {
        return this.hydroProjectMetadata.peakFlow !== waterwayDesignStore.waterwayDesignObject.peakFlow ||
            waterwayDesignStore.initialQFraction !== this.hydrologyForm.initialQFraction ||
            waterwayDesignStore.hydrologyChange === 1;
    }
    // unused function 
    get alignmentChange() {
        return this.selectedAlignmentId !== waterwayDesignStore.alignmentId ||
            waterwayDesignStore.aligmentChange === 2;
    }
    // unused function 
    get alignmentSectionSeedingBufferChange() {
        return this.seedingBufferWidth !== waterwayDesignStore.seedingBufferWidth
    }
    // unused function 
    get designControlChange() {
        return waterwayDesignStore.designControlChange === 1 || (
            this.designControlForm.channelEndControl === 0 ?
                (waterwayDesignStore.startGradeLength !== this.designControlForm.startGradeLength ||
                    waterwayDesignStore.endGradeLength !== this.designControlForm.endGradeLength ||
                    waterwayDesignStore.sideFillSlope !== this.designControlForm.sideFillSlope ||
                    waterwayDesignStore.sideWidthLimit !== this.designControlForm.sideWidthLimit ||
                    waterwayDesignStore.bermBackSlope !== this.designControlForm.bermBackSlope ||
                    waterwayDesignStore.bermTopWidth !== this.designControlForm.bermTopWidth ||
                    waterwayDesignStore.channelControl !== this.designControlForm.channelControl ||
                    waterwayDesignStore.channelEndControl !== this.designControlForm.channelEndControl)
                : (waterwayDesignStore.startGradeSlope !== this.designControlForm.startGradeSlope ||
                    waterwayDesignStore.endGradeSlope !== this.designControlForm.endGradeSlope ||
                    waterwayDesignStore.sideFillSlope !== this.designControlForm.sideFillSlope ||
                    waterwayDesignStore.sideWidthLimit !== this.designControlForm.sideWidthLimit ||
                    waterwayDesignStore.bermBackSlope !== this.designControlForm.bermBackSlope ||
                    waterwayDesignStore.bermTopWidth !== this.designControlForm.bermTopWidth ||
                    waterwayDesignStore.channelControl !== this.designControlForm.channelControl ||
                    waterwayDesignStore.channelEndControl !== this.designControlForm.channelEndControl)
        )
    }

    createSavePayload(): AlignedElementDesignParamsRequestDTO {
        const WaterwayMiscDTO: WaterwayMiscDTO = {
            benchmarkDescription: this.benchmarkDescription,
            spoilDisposal: this.spoilDisposal,
            waterwayMaterial: ""
        }
        if (waterwayDesignStore.waterwayType === "Lined Waterway") {
            WaterwayMiscDTO.waterwayMaterial = `${this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? this.liningMaterailForm.manualEntryLiningMaterailName : this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`;
        }
        return {
            alignedElementDesignParamsId: waterwayDesignStore.alignedDesignElementId ? waterwayDesignStore.alignedDesignElementId : 0,// included if updating
            alignedFeatureSCChange: 0,
            alignmentChange: 0,
            surfaceChange: 0,
            comments: '',
            designElementTypeId: waterwayDesignStore.currentWaterwayDesignElementTypeId
                ? waterwayDesignStore.currentWaterwayDesignElementTypeId
                : (waterwayDesignStore.waterwayType === "Lined Waterway" ? 19 : 7),
            sessionUuid: designStore.projectsStore.currentSessionId,
            alignedFeatureName: waterwayDesignStore.waterwayName ? waterwayDesignStore.waterwayName.trim() : this.waterwayName.trim(),
            waterwayMiscDTO: JSON.stringify(WaterwayMiscDTO),
            constructBenchmark: this.constructionBenchmark,
            benchmarkElevation: this.constructionElevation,
            alignmentDesignElementJsonId: +this.selectedAlignmentId,
            alignmentSeedingBuffer: this.seedingBufferWidth,
            hydroParamsJson: JSON.stringify(this.createHydroParamsDTO()),
            designControlJson: JSON.stringify(this.createDesignControlDTO())
        }

    }
    createSaveDesignUiStatePayload(whichBtn?): EftProjUserInputDto {
        return {
            alignedElementUiStateDto: {
                alignmentElementId: waterwayDesignStore.alignedDesignElementId,
                alignmentId: this.selectedAlignmentId,
                channelShape: this.designControlForm.channelControl,
                designElementTypeId: waterwayDesignStore.currentWaterwayDesignElementTypeId
                    ? waterwayDesignStore.currentWaterwayDesignElementTypeId
                    : (waterwayDesignStore.waterwayType === "Lined Waterway" ? 19 : 7),
                endDistance: this.designControlForm.endGradeLength,
                peakFlow: this.hydroProjectMetadata.peakFlow ? this.hydroProjectMetadata.peakFlow : 0,
                startDistance: this.designControlForm.startGradeLength,
                tableView: 'C',
                uiSettingsDto: undefined,
            },
            sessionUuid: designStore.projectsStore.currentSessionId,
            uiStateType: whichBtn === "save_and_proceed" ? "WaterwayInputProceed" : "WaterwayInputSave",
        }
    }


    createHydroParamsDTO(): HydroParamsDTO {
        return {
            projectUuid: this.hydroProjectMetadata.projectUuid ? this.hydroProjectMetadata.projectUuid : 'User Defined',
            county: this.hydroProjectMetadata.county ? this.hydroProjectMetadata.county : this.Aoi.county,
            state: this.hydroProjectMetadata.state ? this.hydroProjectMetadata.state : this.Aoi.state,
            stormFrequency: parseInt(this.hydrologyForm.hydrologyFrequencySelection.split(' ')[0]),
            watershedLength: this.hydroProjectMetadata.watershedLength,
            watershedSlope: this.hydroProjectMetadata.watershedSlope,
            weightedCurveNumber: this.hydroProjectMetadata.weightedCurveNumber,
            drainageArea: this.hydroProjectMetadata.drainageArea,
            totalRunoff: this.hydroProjectMetadata.runOff,
            initialQPercent: this.hydrologyForm.initialQFraction,
            peakFlowQ: this.hydroProjectMetadata.peakFlow ? this.hydroProjectMetadata.peakFlow : 0,
        }
    }
    createDesignControlDTO(): DesignControlDTO {
        return {
            sideSlope: this.designControlForm.sideFillSlope,
            bermWidth: this.designControlForm.bermTopWidth,
            sideWidthLimit: this.designControlForm.sideWidthLimit,
            backSlopeRatio: this.designControlForm.bermBackSlope,
            computeStartShape: this.computeStartEndShape(0),
            computeEndShape: this.computeStartEndShape(1),
            startSlopeDistance: this.designControlForm.startGradeLength,
            endSlopeDistance: this.designControlForm.endGradeLength,
            endGradeSlope: this.designControlForm.endGradeSlope,
            startGradeSlope: this.designControlForm.startGradeSlope,
            channelEndControl: this.designControlForm.channelEndControl,
            channelControl: this.designControlForm.channelControl,
            channelTranDistance: 0,
            peakFlowQEdited: true,
            channelParameters: undefined,
            freeBoard: this.designControlForm.freeBoard,
            seedingBufferOption: this.designControlForm.seedingBufferOption
        }
    }

    computeStartEndShape(mode): boolean {
        // start
        if (mode === 0) {
            if (this.designControlForm.channelEndControl === 0) {
                return this.designControlForm.startGradeLength === 0 ? false : true;
            }
            else {
                return this.designControlForm.startGradeSlope === 0 ? false : true;
            }
        }
        // end
        else {
            if (this.designControlForm.channelEndControl === 0) {
                return this.designControlForm.endGradeLength === 0 ? false : true;
            }
            else {
                return this.designControlForm.endGradeSlope === 0 ? false : true;
            }
        }
    }

    @action.bound async handleLoadMetadata() {
        await this.getHydroProjectMetadata()
    }
    @action.bound setupLiningMaterialInputs(liningMaterialString) {
        const liningMaterial = liningMaterialString.split('(')[0].trim();
        const match = liningMaterialString.match(/\(([^,]{1,6}), ([^)]{1,5})\)/);
        const manning = parseFloat(match[1]);
        const thickness = parseFloat(match[2]);
        if (liningMaterialOptions.map(e => e.value).includes(liningMaterial)) {
            this.liningMaterailForm.selectedLiningMaterail = liningMaterial
            this.liningMaterailForm.manning = manning;
            this.liningMaterailForm.thickness = thickness;
            this.liningMaterailForm.disabledManual = true;
            this.liningMaterailForm.manualEntryLiningMaterailName = '';
        } else {
            this.liningMaterailForm.selectedLiningMaterail = 'Manual Entry';
            this.liningMaterailForm.manning = manning;
            this.liningMaterailForm.thickness = thickness;
            this.liningMaterailForm.disabledManual = false;
            this.liningMaterailForm.manualEntryLiningMaterailName = liningMaterial;
        }
    }
    @action.bound async getWaterwayInputsByElementDesignParamsId() {
        const paramsId = stores.AppStore.waterwayDesignStore.alignedDesignElementId
        waterwayDesignStore.isLoading = true;
        waterwayDesignStore.checkAlignmentList = false;
        if (paramsId) {
            try {
                const response = await WaterwayDesignToolsController.getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(paramsId);

                if (response && response.data) {
                    const data = response.data;
                    if (data.alignmentBindingName == null) {
                        waterwayDesignStore.checkAlignmentList = true;
                    }
                    //Info form
                    this.waterwayName = data.objectName!;
                    this.constructionBenchmark = "" + data.benchmarkName!;
                    this.constructionElevation = data.benchMark!;
                    // Error: Property 'waterwayMiscDTO' does not exist on type 'WaterwayDTO' (does exist on AlignedElementDesignParamsRequestDTO while benchmark description does not)

                    if (data.waterwayMiscDTO) {
                        const WaterwayMiscDTO = JSON.parse(data.waterwayMiscDTO);
                        if (WaterwayMiscDTO.waterwayMaterial) {
                            this.setupLiningMaterialInputs(WaterwayMiscDTO.waterwayMaterial);
                        }
                        this.spoilDisposal = WaterwayMiscDTO.spoilDisposal;
                        this.benchmarkDescription = WaterwayMiscDTO.benchmarkDescription;
                    }
                    // this.benchmarkElevation this is not available in data
                    //Alignment form
                    this.selectedAlignmentId = data.alignmentJsonId!;
                    this.seedingBufferWidth = data.seedWidth!;
                    if (this.selectedAlignmentId) this.displayAlignment(this.selectedAlignmentId);
                    //Hydro form
                    if (data.hydroParamsDto?.projectUuid === 'User Defined') {
                        this.hydrologyForm.hydrologyProjectSlection = data.hydroParamsDto.projectUuid;
                    }
                    else {
                        this.hydrologyForm.hydrologyProjectSlection = data.hydroParamsDto?.projectUuid?.toLowerCase()!;
                    }
                    this.hydrologyForm.hydrologyFrequencySelection = data.hydroParamsDto?.stormFrequency! + " year";
                    this.hydroProjectMetadata.drainageArea = data.hydroParamsDto?.drainageArea;
                    this.hydroProjectMetadata.weightedCurveNumber = data.hydroParamsDto?.weightedCurveNumber;
                    this.hydroProjectMetadata.watershedLength = data.hydroParamsDto?.watershedLength;
                    this.hydroProjectMetadata.watershedSlope = data.hydroParamsDto?.watershedSlope;
                    this.hydroProjectMetadata.runOff = data.hydroParamsDto?.totalRunoff;
                    this.hydroProjectMetadata.peakFlow = data.hydroParamsDto?.peakFlowQ;
                    //this.designControlForm.initialQFraction = response.data.designControlDto?.initialQPercent!;
                    this.hydroProjectMetadata.county = data.hydroParamsDto?.county;
                    this.hydroProjectMetadata.state = data.hydroParamsDto?.state;
                    this.hydroProjectMetadata.projectUuid = data.hydroParamsDto?.projectUuid;

                    //design control form
                    this.designControlForm.sideFillSlope = data.designControlDto?.sideSlope!;
                    this.designControlForm.sideWidthLimit = data.designControlDto?.sideWidthLimit!;
                    this.designControlForm.bermTopWidth = data.designControlDto?.bermWidth!;
                    this.designControlForm.bermBackSlope = data.designControlDto?.backSlopeRatio!;
                    this.designControlForm.channelEndControl = data.designControlDto?.channelEndControl! as 0 | 1;
                    this.designControlForm.channelControl = data.designControlDto?.channelControl! as "TRAPEZOIDAL" | "PARABOLIC";

                    this.designControlForm.startGradeLength = data.designControlDto?.startSlopeDistance!;
                    this.designControlForm.endGradeLength = data.designControlDto?.endSlopeDistance!;
                    this.designControlForm.endGradeSlope = Number(data.designControlDto?.endGradeSlope!.toFixed(2));
                    this.designControlForm.startGradeSlope = Number(data.designControlDto?.startGradeSlope!.toFixed(2));
                    this.designControlForm.seedingBufferOption = Number(data.designControlDto?.seedingBufferOption);

                    this.hydrologyForm.initialQFraction = data.hydroParamsDto?.initialQPercent!;
                    this.designControlForm.freeBoard = data.designControlDto?.freeBoard!;
                    waterwayDesignStore.globalFreeBoard = this.designControlForm.freeBoard

                    // Save input data to store for design step
                    waterwayDesignStore.saveInputPayloadAndId(
                        this.createSavePayload(),
                        paramsId,
                        this.waterwayName.trim(),
                        this.designControlForm.channelControl,
                        this.designControlForm.startGradeLength,
                        this.designControlForm.endGradeLength,
                        this.hydroProjectMetadata.peakFlow,
                        this.designControlForm.sideFillSlope,
                        this.designControlForm.sideWidthLimit,
                        this.designControlForm.bermTopWidth,
                        this.designControlForm.bermBackSlope,
                        this.designControlForm.endGradeSlope,
                        this.designControlForm.startGradeSlope,
                        this.hydrologyForm.initialQFraction,
                        this.designControlForm.channelEndControl,
                        this.selectedAlignmentId,
                        this.seedingBufferWidth,
                        this.designControlForm.freeBoard,
                        this.liningMaterailForm.selectedLiningMaterail === 'Manual Entry' ? `${this.liningMaterailForm.manualEntryLiningMaterailName} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                            : `${this.liningMaterailForm.selectedLiningMaterail} (${this.liningMaterailForm.manning}, ${this.liningMaterailForm.thickness})`
                    );
                    const reqIndex = this.HydroByAlignmentAoiData.findIndex(item => item.projectUuid === this.hydrologyForm.hydrologyProjectSlection);
                    if (reqIndex === -1) {
                        waterwayDesignStore.selectedHydroProjectName = 'User Defined';
                    }
                    else {
                        waterwayDesignStore.selectedHydroProjectName = this.HydroByAlignmentAoiData[reqIndex].projectTitle;
                    }
                    await this.validateReqInputOnLoad();
                }
            }
            catch (error) {
                // console.error('getWaterwayInputsByElementDesignParamsId error:', error)
            }
            finally {
                if (this.validateRequiredInputs) {
                    waterwayDesignStore.requiredInputsValidated = true;
                } else {
                    waterwayDesignStore.requiredInputsValidated = false;
                }
                waterwayDesignStore.isLoading = false;
            }
        }
        waterwayDesignStore.isLoading = false;
    }

    @action.bound adjustStartAndEndStationLengthAndSlope() {
        const stations = waterwayDesignStore?.waterwayDesignObject?.waterwayDesignStations;
        const startStation = stations?.[0];
        const endStation = stations?.[stations.length - 1];

        if (startStation && this.designControlForm.startGradeLength !== 0 && this.designControlForm.startGradeLength !== startStation.stationLength) {
            startStation.stationLength = this.designControlForm.startGradeLength;
            waterwayDesignStore.waterwayDesignObject.startGradeLength = this.designControlForm.startGradeLength;
        }
        if (endStation && this.designControlForm.endGradeLength !== 0 && this.designControlForm.endGradeLength !== endStation.stationLength) {
            endStation.stationLength = this.designControlForm.endGradeLength;
            waterwayDesignStore.waterwayDesignObject.endGradeLength = this.designControlForm.endGradeLength;
        }
        if (startStation && this.designControlForm.startGradeSlope !== 0 && this.designControlForm.startGradeSlope !== startStation.grade) {
            startStation.grade = this.designControlForm.startGradeSlope;
            waterwayDesignStore.waterwayDesignObject.startGuardrail = this.designControlForm.startGradeSlope;

        }
        if (endStation && this.designControlForm.endGradeSlope !== 0 && this.designControlForm.endGradeSlope !== endStation.grade) {
            endStation.grade = this.designControlForm.endGradeSlope;
            waterwayDesignStore.waterwayDesignObject.endGuardrail = toDecimalPrecision((waterwayDesignStore.endStation_XCenterLine - (this.designControlForm.endGradeSlope / 100 ? parseFloat((this.designControlForm.endGradeSlope / 100).toFixed(2)) : 0)), 1);

        }
    }

    @action.bound async getAlldataonMount() {
        designStore.setLoader('Loading Waterway Inputs...');
        waterwayDesignStore.waterwayInputsPageInputsChange = false;
        waterwayDesignStore.waterwaySummaryBannerReportObj = undefined;
        waterwayDesignStore.loadingComplete = false;
        // this.resetLiningMaterial();
        if (stores.AppStore.designStore.projectsStore.currentSessionId) {
            await this.getAllAlignments();
        }
        if (this.Aoi.county && this.Aoi.state) {
            await this.getHydroByAlignmentAoiData();
        }
        if (stores.AppStore.waterwayDesignStore.alignedDesignElementId) {
            await this.getWaterwayInputsByElementDesignParamsId();
            if (waterwayDesignStore.aligmentChange < 2) {
                this.adjustStartAndEndStationLengthAndSlope();
                if ((waterwayDesignStore.uiState === 'ReachDesignCalculate') ||
                    (waterwayDesignStore.uiState === 'ReachDesignSurface')) {
                    await this.getResultsSummary();
                    await this.generateWWSurfaceAndShape();
                }
            }
            else if (waterwayDesignStore.aligmentChange === 2) {
                waterwayDesignStore.waterwayDesignObject.waterwayDesignStations = [];
            }
        }
        waterwayDesignStore.loadingComplete = true;

        // I moved the following to WaterwayDesignVM's constructor. Don't think we need it here.
        // // Clone object on reload if reaches exist
        // if (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
        //     waterwayDesignStore.wdtGroupsOriginals = [];
        //     waterwayDesignStore.wdtGroupsOriginals.push(
        //         {
        //             groupCount: 0,
        //             currentObject: JSON.parse(JSON.stringify(waterwayDesignStore.waterwayDesignObject))
        //         }
        //     );
        // }
        designStore.setLoader('');
    }

    @action.bound async getResultsSummary() {
        try {
            // calling waterwayresultssummary API only when waterwaySimulationAndValidation API is Warning or Passed!
            if (!waterwayDesignStore.alignedDesignElementId) {
                return;
            }
            if (!waterwayDesignStore.waterwayDesignObject ||
                !waterwayDesignStore.waterwayDesignObject.waterwayDesignStations ||
                waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0 ||
                waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.find(
                    (waterwayDesignStation) =>
                        waterwayDesignStation.status === 'ERROR' || waterwayDesignStation.status === 'IN PROGRESS'
                )
            ) {
                return;
            }
            const resultsValues = await WaterwayDesignToolsController.getWaterwaySummaryResultsUsingGET(waterwayDesignStore.alignedDesignElementId);
            waterwayDesignStore.waterwaySummaryBannerReportObj = resultsValues.data;
            designStore.displayResultBanner = true;
        } catch (err) {
            // console.error('error: getWaterwaySummaryResults()', err)
        }
    }

    @action.bound async generateWWSurfaceAndShape() {
        if (!waterwayDesignStore.alignedDesignElementId) {
            return;
        }
        if (!waterwayDesignStore.waterwayDesignObject ||
            !waterwayDesignStore.waterwayDesignObject.waterwayDesignStations ||
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0 ||
            waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.find(
                (waterwayDesignStation) =>
                    waterwayDesignStation.status === 'ERROR' || waterwayDesignStation.status === 'IN PROGRESS'
            )
        ) {
            console.warn("WATERWAY NOT YET CALCULATED; NOT DISPLAYING ON THE MAP.");
            return;
        }
        let errorCode = "WDT_81";
        try {
            const surfaceText = (waterwayDesignStore.uiState === 'ReachDesignSurface' ? "surface and " : "");
            designStore.setLoader(`Loading ${surfaceText}channel shape...`);
            const wwDesignId = waterwayDesignStore.alignedDesignElementId;
            let channelResult: any;
            let turnOnTin: boolean = false;
            const response = await WaterwayDesignToolsController.getAlignedElementShapeByAlignedElementIdUsingGET(wwDesignId);
            if (response && response.data && response.data.alignedFeatureDesignShapeJson) {
                channelResult = JSON.parse(response.data.alignedFeatureDesignShapeJson);
                if (!channelResult.alignedStructureShapeDTO) {
                    throw new Error("Failed to retrieve channel data from the service.");
                };
                if ((!channelResult.contourLines || channelResult.contourLines.length === 0) && channelResult.tinTriangles) {
                    MessageCenter.addWarningFromCode('WDT_133');
                    turnOnTin = true;
                };
            } else {
                throw new Error("Failed to retrieve channel data from the service.");
            }

            if ((waterwayDesignStore.uiState === 'ReachDesignSurface') &&
                (channelResult.tinTriangles || channelResult.contourLines)) {
                await DesignContainerVM.loadSurfaceFromData(
                    channelResult.tinTriangles,
                    undefined,
                    channelResult.contourLines,
                    undefined,
                    undefined,
                    true
                );
                if (turnOnTin && this.mapView) {
                    const DesignedTinTrianglesLayer = this.mapView.map.findLayerById(AppConstants.DesignedTinTrianglesLayerId) as GraphicsLayer;
                    if (DesignedTinTrianglesLayer) {
                        DesignedTinTrianglesLayer.visible = true;
                    }
                }
            }

            if (this.mapView) {
                if (waterwayDesignStore.uiState === 'ReachDesignCalculate') {
                    await DesignContainerVM.loadOriginalSurface();
                    const SurveyPointsLayer = this.mapView.map.findLayerById(AppConstants.SurveyPointsLayerId) as GraphicsLayer;
                    if (SurveyPointsLayer) {
                        SurveyPointsLayer.visible = false;
                    }
                };
                waterwayDesignStore.addWaterwayToMap(
                    channelResult.alignedStructureShapeDTO,
                    this.mapView,
                    wwDesignId.toString(),
                    waterwayDesignStore.alignedFeatureName
                );
                if (!designStore.hideSingleCrossSection) {
                    designStore.validateSingleCrossSection(this.mapView, 'CS_3');
                }
            }
        } catch (e) {
            console.warn(`WATERWAY MAPPING ERROR: ${(e as Error).message}`);
            await MessageCenter.addErrorFromCode(errorCode, [
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                    },
                    text: 'OK',
                },
            ]);
        } finally {
            designStore.setLoader("");
        }
    }

    @action.bound async getHydroProjectMetadata() {
        const reqObj = {
            frequencyInYrs: parseInt(this.hydrologyForm.hydrologyFrequencySelection),
            projectUuid: this.hydrologyForm.hydrologyProjectSlection,
        };
        try {
            const response = await EftProjectController.getHydroProjectMetadataUsingPOST(reqObj);
            if (response && response.data) {
                this.hydroProjectMetadata = response.data;
                await this.validateInput("peak_flow", this.hydroProjectMetadata.peakFlow);
            }
        }
        catch (error) {
            await MessageCenter.addNotificationFromCode('WDT_66')
            this.onClickMetaData = false;
            // console.error('getHydroProjectMetadataUsingPOST error:', error);
        }
    }

    updateStartEndLength() {
        if (waterwayDesignStore.updateStartEndLength) {
            this.designControlForm.startGradeLength = waterwayDesignStore.startGradeLength;
            this.designControlForm.endGradeLength = waterwayDesignStore.endGradeLength;
            waterwayDesignStore.updateStartEndLength = false;
        };
    }

    @action.bound handleCancelEdits() {
        if (waterwayDesignStore.waterwayInputsPageInputsChange) {
            MessageCenter.addWarning(waterwayDesignStore.notifications.unsavedEditsClosePage, [
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                    },
                    text: 'Cancel',
                },
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                        waterwayDesignStore.reset();
                        this.props.toggleAddWaterwayClicked();
                        // this.WaterwayMiscDTO.waterwayMaterial = "";
                    },
                    text: 'OK',
                },
            ], 'WDT_115');
        } else {
            MessageCenter.clearMessages();
            waterwayDesignStore.reset();
            this.props.toggleAddWaterwayClicked();
        }
    }
}
